
import { INonAutoPolicySummary, ICustomerType } from "../../resources/interfaces";

export default class NonAutoPolicySummary {
    active: boolean;
    activeAndValid: boolean;
    brokerId: number;
    brokerName: string;
    commissionRateType: string;
    commissionRateValue: number;
    countryId: number;
    countryName: string;
    createdOn: string;
    currency: string;
    customerFirstName: string;
    customerFullName: string;
    customerId: number;
    customerLastName: string;
    customerPhone: string;
    expired: boolean;
    expiryDate: string;
    grossPremium: number;
    id: number;
    inceptionDate: string;
    insurerId: number;
    insurerName: string;
    netPremium: number;
    paidPremium: number;
    policyCategory: string;
    policyId: number;
    policyNumber: string;
    policyTerm: string;
    policyType: string;
    reviewStage: string;
    staffId: number;
    staffName: string;
    sumInsured: string;
    updatedOn: string;
    insurerPolicyNumber: string;
    premiumPaidToInsurer: boolean;
    settlementReceivedByBroker: boolean;
    customerType?: ICustomerType;
    businessName?: string;
    renewed?: boolean



    constructor(data: INonAutoPolicySummary) {
        this.id = data.id;
        this.active = data.active;
        this.activeAndValid = data.activeAndValid;
        this.brokerId = data.brokerId;
        this.brokerName = data.brokerName;
        this.commissionRateType = data.commissionRateType;
        this.commissionRateValue = data.commissionRateValue;
        this.countryId = data.countryId;
        this.countryName = data.countryName;
        this.createdOn = data.createdOn;
        this.currency = data.currency;
        this.customerFirstName = data.customerFirstName;
        this.customerFullName = data.customerFullName;
        this.customerId = data.customerId;
        this.customerLastName = data.customerLastName;
        this.customerPhone = data.customerPhone;
        this.expired = data.expired;
        this.expiryDate = data.expiryDate;
        this.grossPremium = data.grossPremium;
        this.inceptionDate = data.inceptionDate;
        this.insurerId = data.insurerId;
        this.insurerName = data.insurerName;
        this.netPremium = data.netPremium;
        this.paidPremium = data.paidPremium;
        this.policyCategory = data.policyCategory;
        this.policyId = data.policyId;
        this.policyNumber = data.policyNumber;
        this.policyTerm = data.policyTerm;
        this.policyType = data.policyType;
        this.reviewStage = data.reviewStage;
        this.staffId = data.staffId;
        this.staffName = data.staffName;
        this.sumInsured = data.sumInsured;
        this.updatedOn = data.updatedOn;
        this.insurerPolicyNumber = data.insurerPolicyNumber;
        this.premiumPaidToInsurer = data.premiumPaidToInsurer;
        this.settlementReceivedByBroker = data.settlementReceivedByBroker;
        this.customerType = data.customerType;
        this.businessName = data.businessName;
        this.renewed = data.renewed;
    }
}